export default __webpack_public_path__ + "static/media/PreOrder.1da5ddef.svg";